var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"trip resource-list-item",class:{ 'is-dark': _vm.$themeDark },attrs:{"to":`/trip/${_vm.trip.uuid}`}},[_c('div',{staticClass:"trip-title"},[_vm._v(_vm._s(_vm.trip.createdAt.format(_vm.system.settings.datetimeFormat))+" - "+_vm._s(_vm.trip.lastPositionAt.format(_vm.system.settings.datetimeFormat)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }